import { FC } from "react";
import SkeletonMain from "../LoadingMain";
import ColumnHeader from "Components/UI/Table/ColumnHeader";
import styles from "./LoadingNewNotification.module.scss";

export interface ILoadingNewNotification {
  multiple?: number;
}

const LoadingNewNotification: FC<ILoadingNewNotification> = ({ multiple = 1 }) => {
  const skeletonObra = {
    render: (index: number) => {
      return (
        <tr key={index.toString()} className={styles['rowTable']}>
          <td>
            <span className={styles['rowName']}>
              <SkeletonMain width="24px" height="24px" borderRadius="50%" marginLeft="68px" minWidth="24px" />
              <SkeletonMain width="100%" height="12px" borderRadius="2px" marginLeft="12px" minWidth="146px" maxWidth="268px" />
            </span>
          </td>
          <td style={{ width: '300px' }}>
            <span className={styles['rowName']}>
              <SkeletonMain width="18px" height="18px" borderRadius="2px" marginLeft="12px" minWidth="18px" />
              <SkeletonMain width="100%" height="12px" borderRadius="2px" marginLeft="12px" minWidth="56px" />
            </span>
            <span className={styles['rowName']}>
              <SkeletonMain width="100%" height="12px" borderRadius="2px" marginLeft="12px" minWidth="56px" marginTop="4px" />
            </span>
          </td>
          <td style={{ width: '250px' }}>
            <span className={styles['rowName']}>
              <SkeletonMain width="24px" height="24px" borderRadius="50%" marginLeft="16px" minWidth="24px" />
              <SkeletonMain width="100%" height="12px" borderRadius="2px" marginLeft="10px" minWidth="150px" />
            </span>
          </td>
          <td style={{ width: '200px' }}>
            <span className={styles['rowName']}>
              <SkeletonMain width="32px" height="12px" borderRadius="2px" minWidth="32px" marginLeft="16px" />
            </span>
          </td>
          <td style={{ width: '40px' }}>
            <span className={styles['rowName']}>
              <SkeletonMain width="8px" height="8px" borderRadius="50%" minWidth="8px" marginLeft="16px" />
            </span>
          </td>
        </tr>
      )
    }
  }

  const multipleSkeletonsObras = [];
  for (let i = 0; i < multiple; i++) {
    multipleSkeletonsObras.push(skeletonObra);
  }

  return (
    <>
      <table className={styles['renderTable']}>
        <thead className={styles['headTable']}>
          <tr>
            <th style={{ paddingLeft: '50px' }}>
              <ColumnHeader title="Ação" />
            </th>
            <th style={{ width: '300px' }}>
              <ColumnHeader title="" showOrder={false} />
            </th>
            <th style={{ width: '250px' }}>
              <ColumnHeader title="Obra" showOrder={false} />
            </th>
            <th style={{ width: '200px' }}>
              <ColumnHeader title="Data" />
            </th>
            <th style={{ width: '40px' }}>
              <ColumnHeader title="" showOrder={false} />
            </th>
          </tr>
        </thead>

        <tbody className={styles['rowTable']}>
          {multipleSkeletonsObras.map((skeleton, index) => skeleton.render(index))}
        </tbody>
      </table>
    </>
  )
}

export default LoadingNewNotification;
